module.exports = __webpack_public_path__ + "static/banner-sobre-mobile-d22a2354f94350e07d457653858e21d0.jpg";